"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OLD_LIST = exports.WHITE_LIST = void 0;
exports.WHITE_LIST = [
    'ecency.com',
    'hive.blog',
    'peakd.com',
    'travelfeed.io',
    'dapplr.in',
    'leofinance.io',
    'inleo.io',
    'proofofbrain.io',
    'stemgeeks.net',
    'hiveblockexplorer.com',
    'proofofbrain.blog',
    'weedcash.network',
    'dapplr.in',
    'liketu.com',
    'bilpcoin.com',
    'inji.com'
];
exports.OLD_LIST = [
    'busy.org',
    'steemit.com',
    'esteem.app',
    'steempeak.com',
    'partiko.app',
    'chainbb.com',
    'utopian.io',
    'steemkr.com',
    'strimi.pl',
    'steemhunt.com',
    'ulogs.org',
    'hede.io',
    'naturalmedicine.io'
];
//# sourceMappingURL=white-list.const.js.map